// CatalogActiveChips.tsx
import { Box, Chip } from '@mui/material';
import {
  getActiveFilterChips,
  type FilterFieldConfig,
} from '../../../components/CatalogFilterModel/filterModel';
import { searchChipLabel } from '../../../components/CatalogFilterModel/catalogSearchScope';
import type { SearchScope } from '../../../components/CatalogFilterModel/catalogSearchScope';
import type { CatalogFiltersType } from './useCatalogTable';

interface CatalogActiveChipsProps {
  searchQuery: string;
  searchScope: SearchScope;
  onClearSearch: () => void;
  filters: CatalogFiltersType | undefined;
  filterFields: FilterFieldConfig[];
  onClearFilterKeys: (keys: string[]) => void;
  similarToTitle: string | null;
  onClearSimilar: () => void;
}

export const CatalogActiveChips = ({
  searchQuery,
  searchScope,
  onClearSearch,
  filters,
  filterFields,
  onClearFilterKeys,
  similarToTitle,
  onClearSimilar,
}: CatalogActiveChipsProps) => {
  const filterChips = getActiveFilterChips(filters, filterFields);
  const hasAny =
    searchQuery.trim() !== '' || filterChips.length > 0 || similarToTitle != null;

  if (!hasAny) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {searchQuery.trim() !== '' && (
        <Chip
          label={searchChipLabel(searchScope, searchQuery)}
          onDelete={onClearSearch}
        />
      )}
      {filterChips.map((chip) => (
        <Chip
          key={chip.id}
          label={chip.label}
          onDelete={() => onClearFilterKeys(chip.keys)}
        />
      ))}
      {similarToTitle != null && (
        <Chip
          label={`Similar To: ${similarToTitle}`}
          onDelete={onClearSimilar}
        />
      )}
    </Box>
  );
};
